import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { AtenttionResponseEntity } from '../../../data/repositories/consult/entities/attention-response.entity';
import { ConsentConsultModel } from '../../models/consult/consent.model';


export class SignConsentUseCase implements UseCase<ConsentConsultModel, AtenttionResponseEntity> {
    constructor(private attention: ConsultRepository) { }
    execute(
        params: ConsentConsultModel,
    ): Observable<AtenttionResponseEntity> {
        return this.attention.signConsent(params);
    }
}
